module.exports = __webpack_public_path__ + "static/media/nike-like-a-lioness-lotte.4ef00b60.gif";